import { PillarCode } from '../session/orchestration/tool-protocol/follow-up-refs.js';
import { AttachedResultKind } from './enums.js';

export const ATTACHED_KIND_BY_PILLAR: Record<PillarCode, AttachedResultKind | null> = {
  [PillarCode.Hotels]: AttachedResultKind.Hotels,
  [PillarCode.Flights]: AttachedResultKind.Flights,
  [PillarCode.Jobs]: null,
  [PillarCode.Products]: null,
  [PillarCode.Places]: null,
  [PillarCode.RealEstate]: null,
  [PillarCode.Academic]: null,
  [PillarCode.Patents]: null,
  [PillarCode.Social]: null,
  [PillarCode.Youtube]: null,
  [PillarCode.Books]: null,
  [PillarCode.ClassicTexts]: null,
  [PillarCode.HistoricalDocuments]: null,
  [PillarCode.Scriptures]: null,
  [PillarCode.Github]: null,
  [PillarCode.News]: null,
  [PillarCode.WebSearch]: null,
  [PillarCode.Answer]: null,
  [PillarCode.MediaVisual]: null,
  [PillarCode.Concerts]: null,
  [PillarCode.Finance]: null,
  [PillarCode.Trends]: null,
  [PillarCode.Weather]: null,
  [PillarCode.Knowledge]: null,
  [PillarCode.Apps]: null,
  [PillarCode.Music]: null,
  [PillarCode.Workouts]: null,
  [PillarCode.Nutrition]: null,
};

export function attachedKindForPillar(input: { pillar: PillarCode }): AttachedResultKind {
  return ATTACHED_KIND_BY_PILLAR[input.pillar] ?? AttachedResultKind.Links;
}
